export default __webpack_public_path__ + "static/media/2026-03-27 12.29.47.682641f3.jpg";